import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API });

export const fetchProducts = () => api.get("/products").then((r) => r.data);
export const submitInquiry = (data) => api.post("/inquiries", data).then((r) => r.data);
export const adminLogin = (password) => api.post("/admin/login", { password }).then((r) => r.data);
export const fetchInquiries = (token) =>
  api.get("/admin/inquiries", { headers: { Authorization: `Bearer ${token}` } }).then((r) => r.data);
